import React, { useContext, useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { BiChevronDown } from "react-icons/bi";
import NavData from "../static-data/NavItems.json";
import GlobalPkgDrpDwn from "./nav-dropdowns/GlobalPkgDrpDwn";
import MblGlobalDrpDwn from "./nav-dropdowns/MblGlobalDrpDwn";
import MblLocalDrpDwn from "./nav-dropdowns/MblLocalDrpDwn";
import Languages from "./nav-dropdowns/Languages";
import { routeType } from "./Nav";
import LangContext from "../../context/LangContext";

type Props = {
  handleRoute: (route: routeType, searchParam: {} | null) => void;
  activePage: string;
};
const MobileNav: React.FC<Props> = ({ handleRoute, activePage }) => {
  const { lang_code } = useContext(LangContext);
  const [sideBarStatus, setSideBarStatus] = useState(false);
  const [dropDwnMenu, setDropDwnMenu] = useState("");

  const handleDropDwn = (menu: string) => {
    if (dropDwnMenu === menu) {
      setDropDwnMenu("");
    } else {
      setDropDwnMenu(menu);
    }
  };

  const handleSideMenu = () => {
    setSideBarStatus(!sideBarStatus);
  };

  return (
    <div className="">
      <div className="flex items-center justify-between px-8 py-4">
        <a href="/">
          <h1 className="font-bold">ULTIMATE TREKKING</h1>
        </a>
        {/* right section  */}
        {/* TODO: use handburger icon here */}
        <button className="" onClick={() => handleSideMenu()}>
          <AiOutlineMenu className="text-2xl" />
        </button>
      </div>

      {/* sideBar */}
      <div
        className={`fixed top-0 bg-white shadow-xl h-screen overflow-y-auto w-3/4 z-10 ${
          sideBarStatus
            ? "visible block animate-from-right opacity-100 right-0"
            : "transition-transform duration-500 transform -translate-x-[100%]"
        } `}
      >
        <div className="flex items-center justify-between px-6 pt-8">
          <a href="/">
            <h1 className="text-primary-base font-bold">
              HIMALAYAN Ultimate trekking
            </h1>
          </a>
          <AiOutlineClose
            className="text-black text-2xl"
            onClick={() => handleSideMenu()}
          />
        </div>
        <hr className="my-4" />
        <div className="flex flex-col text-black px-6 text-lg">
          {/* Home Nav  */}
          <p
            className={`relative py-3 testringxt-lg ${
              activePage === `${[NavData[0]["nav-item"]]}` &&
              "text-primary-base"
            }`}
            onClick={() => {
              handleRoute(NavData[0], null);
              handleSideMenu();
            }}
          >
            {NavData[0]["nav-item"][`${lang_code}`]}
          </p>
          {/* Global Package Nav  */}
          <div
            className="flex items-center justify-between"
            onClick={() => {
              handleDropDwn(NavData[1]["nav-item"][`${lang_code}`]);
            }}
          >
            <p
              className={`relative py-3 text-lg ${
                activePage === `${[NavData[1]["nav-item"]]}` &&
                "text-primary-base"
              }`}
            >
              {NavData[1]["nav-item"][`${lang_code}`]}
            </p>
            <BiChevronDown
              className={`${
                dropDwnMenu === NavData[1]["nav-item"][`${lang_code}`]
                  ? "transfrom rotate-180 transition-all duration-300"
                  : "transform rotate-0 transition-all duration-300 "
              }`}
            />
          </div>
          {/* Global pkg dropdown  */}
          <div
            className={`${
              dropDwnMenu === NavData[1]["nav-item"][`${lang_code}`]
                ? "h-fit bg-white  w-full py-4 transition-all duration-300 ease-linear "
                : "h-0 overflow-hidden transition-all duration-300 ease-linear "
            }`}
          >
            <MblGlobalDrpDwn handleRoute={handleRoute} />
          </div>
          {/* Explore Local Nav  */}
          <div
            className="flex items-center justify-between"
            onClick={() => {
              handleDropDwn(NavData[2]["nav-item"][`${lang_code}`]);
            }}
          >
            <p
              className={`relative py-3 text-lg ${
                activePage === `${[NavData[2]["nav-item"]]}` &&
                "text-primary-base"
              }`}
            >
              {NavData[2]["nav-item"][`${lang_code}`]}
            </p>
            <BiChevronDown
              className={`${
                dropDwnMenu === NavData[1]["nav-item"][`${lang_code}`]
                  ? "transfrom rotate-180 transition-all duration-300"
                  : "transform rotate-0 transition-all duration-300 "
              }`}
            />
          </div>
          {/* Explore local pkg dropdown  */}
          <div
            className={`${
              dropDwnMenu === NavData[2]["nav-item"][`${lang_code}`]
                ? "h-fit bg-white  w-full py-4 transition-all duration-300 ease-linear "
                : "h-0 overflow-hidden transition-all duration-300 ease-linear "
            }`}
          >
            <MblLocalDrpDwn handleRoute={handleRoute} />
          </div>
          {/* Travel Guide Nav  */}
          <p
            className={`relative py-3 text-lg ${
              activePage === `${[NavData[3]["nav-item"]]}` &&
              "text-primary-base"
            }`}
            onClick={() => {
              handleRoute(NavData[3], null);
              handleSideMenu();
            }}
          >
            {NavData[3]["nav-item"][`${lang_code}`]}
          </p>
          {/* Blog Nav  */}
          <p
            className={`relative py-3 text-lg ${
              activePage === `${[NavData[4]["nav-item"]]}` &&
              "text-primary-base"
            }`}
            onClick={() => {
              handleRoute(NavData[4], null);
              handleSideMenu();
            }}
          >
            {NavData[4]["nav-item"][`${lang_code}`]}
          </p>
          {/* Review Nav  */}
          <p
            className={`relative py-3 text-lg ${
              activePage === `${[NavData[5]["nav-item"]]}` &&
              "text-primary-base"
            }`}
            onClick={() => {
              handleRoute(NavData[5], null);
              handleSideMenu();
            }}
          >
            {NavData[5]["nav-item"][`${lang_code}`]}
          </p>
          {/* About us Nav  */}
          <div
            className="flex items-center justify-between"
            onClick={() => {
              handleRoute(NavData[6], null);
              handleSideMenu();
            }}
          >
            <p
              className={`relative py-3 text-lg ${
                activePage === `${[NavData[6]["nav-item"]]}` &&
                "text-primary-base"
              }`}
            >
              {NavData[6]["nav-item"][`${lang_code}`]}
            </p>
            {/* <BiChevronDown
              className={`${
                dropDwnMenu === NavData[6]["nav-item"][`${lang_code}`]
                  ? "transfrom rotate-180 transition-all duration-300"
                  : "transform rotate-0 transition-all duration-300 "
              }`}
            /> */}
          </div>
          {/* About us  dropdown  */}
          {/* <div
            className={`${
              dropDwnMenu === NavData[6]["nav-item"][`${lang_code}`]
                ? "h-fit bg-gray-200  w-full py-4 transition-all duration-300 ease-linear "
                : "h-0 overflow-hidden transition-all duration-300 ease-linear "
            }`}
          >
            <div className="px-3 py-2">hello</div>
            <div className="px-3 py-2">world</div>
            <div className="px-3 py-2">whats up</div>
          </div> */}
          {/* contact us Nav  */}
          <p
            className={`relative py-3 text-lg ${
              activePage === `${[NavData[7]["nav-item"]]}` &&
              "text-primary-base"
            }`}
            onClick={() => {
              handleRoute(NavData[7], null);
              handleSideMenu();
            }}
          >
            {NavData[7]["nav-item"][`${lang_code}`]}
          </p>
          <hr className="my-4" />
          <p className="text-gray-500 mb-4">Choose language</p>
          <Languages />
        </div>
      </div>
      {sideBarStatus && (
        <div
          className={`transition duration-200 ease-in-out fixed top-0 bg-black h-screen w-full z-0 bg-opacity-70 blur-sm`}
          onClick={() => handleSideMenu()}
        ></div>
      )}
    </div>
  );
};

export default MobileNav;
